import React from "react";
import { FiFolder, FiBell, FiBarChart2, FiPlus } from "react-icons/fi";
import { hasPermission } from "utils/HasPermission";

type HeaderCard = {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  isDisable?: boolean;
};

type Props = {
  onGoQuestionBank?: () => void;
  onGoActiveSurveys?: () => void;
  onGoDashboard?: () => void;
  onCreateSurvey?: () => void;
  isActive?: boolean;
};

const Card = ({
  title,
  subtitle,
  icon,
  onClick,
  active,
  isDisable,
}: HeaderCard) => {
  return (
    <button
      disabled={isDisable}
      type="button"
      onClick={onClick}
      className={`w-full rounded-2xl border px-6 py-7 shadow-sm transition-all flex flex-col items-center justify-center gap-3 select-none
        ${
          isDisable
            ? "bg-gray-50 border-gray-200 opacity-60 cursor-not-allowed shadow-none"
            : active
            ? "bg-[#7a1b2b] border-[#7a1b2b] text-white shadow-md cursor-pointer hover:shadow-lg"
            : "bg-white border-gray-100 hover:shadow-md cursor-pointer hover:border-gray-200"
        }`}
      // className={`w-full rounded-2xl border px-6 py-7 shadow-sm transition flex flex-col items-center justify-center gap-3
      //   ${
      //     active
      //       ? "bg-[#7a1b2b] border-[#7a1b2b] text-white shadow-md"
      //       : "bg-white border-gray-100 hover:shadow-md"
      //   }`}
    >
      <div
        className={`w-14 h-14 rounded-2xl flex items-center justify-center
          ${active ? "bg-white/15" : "bg-gray-50"}`}
      >
        {icon}
      </div>

      <div className="text-center">
        <div
          className={`text-base font-bold ${
            active ? "text-white" : "text-gray-800"
          }`}
        >
          {title}
        </div>
        <div
          className={`text-xs mt-1 ${
            active ? "text-white/80" : "text-gray-500"
          }`}
        >
          {subtitle}
        </div>
      </div>
    </button>
  );
};

const SurveyTopHeader: React.FC<Props> = ({
  onGoQuestionBank,
  onGoActiveSurveys,
  onGoDashboard,
  onCreateSurvey,
  isActive,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <Card
        title="بانک سوالات"
        subtitle="مدیریت مخزن سوالات"
        onClick={onGoQuestionBank}
        icon={<FiFolder className="text-[#7a1b2b]" size={26} />}
        isDisable={!hasPermission("SURVEY_QUESTION_BANK")}
      />

      <Card
        title={!isActive ? "نظرسنجی‌های فعال" : "نظرسنجی‌های غیرفعال"}
        subtitle={
          !isActive ? "لیست کمپین‌های در حال اجرا" : "لیست کمپین‌های متوقف شده"
        }
        onClick={onGoActiveSurveys}
        active={!!isActive}
        icon={
          <FiBell
            className={isActive ? "text-white" : "text-[#7a1b2b]"}
            size={26}
          />
        }
      />

      <Card
        title="داشبورد نتایج"
        subtitle="مشاهده امتیازات و گزارش‌ها"
        onClick={onGoDashboard}
        icon={<FiBarChart2 className="text-[#7a1b2b]" size={26} />}
        isDisable={!hasPermission("SURVEY_RESULTS_DASHBOARD")}
      />

      <Card
        title="ایجاد نظرسنجی"
        subtitle="ساخت فرم جدید با Drag & Drop"
        onClick={onCreateSurvey}
        icon={<FiPlus className="text-[#7a1b2b]" size={26} />}
        isDisable={!hasPermission("SURVEY_CREATE")}
      />
    </div>
  );
};

export default SurveyTopHeader;
